export const getSizeType = (portion, item) => {
    if (!portion || !portion.size) return "";
    let { brandType, category, subMenu } = item || {};

    // Fallback to populated menuItem if brandType or category are missing (for older orders)
    if (!brandType && item?.menuItem) {
        brandType = item.menuItem.brandType;
    }
    if (!category && item?.menuItem) {
        category = item.menuItem.category;
    }

    const { size } = portion;

    if (brandType === "kepsa_queue") {
        const kepsaCategories = [
            "Veg kepsa",
            "Non-veg kepsa",
            "Veg Biryani",
            "Non-veg biryani",
        ];

        if (kepsaCategories.includes(category)) {
            if (size === "medium") {
                return "Serves 1-2";
            } else {
                return "Serves 4-5";
            }
        }
    }

    if (brandType === "gutful_greens" && category === "Flavoured protein") {
        const sizeMap = {
            small: "150g",
            medium: "200g",
            large: "300g",
        };

        return sizeMap[size].toUpperCase() || size.toUpperCase();
    }

    if (brandType === "gutful_greens" && category === "Low-Kcal Protein Biryani") {
        return subMenu?.find((sub) => sub?.price === portion?.price)?.name ?? size;
    }

    if (brandType === "gravy_ganj") {
        const gravyCategories = [
            "Veg main course",
            "Non-veg main course",
        ];

        if (gravyCategories.includes(category)) {
            if (size === "medium") {
                return "Serves 1-2";
            } else {
                return "Serves 2-3";
            }
        }
    }

    return size.toUpperCase();
};
